import Vue from 'vue';
import { mapGetters } from 'vuex';
import AuthMixin from '@/mixins/Auth';
import Hero from '@/components/Hero/Hero.vue';
import Loading from '@/views/Loading.vue';
import Snackbar from '@/components/Snackbar';
import TableGamesPlayed from '@/components/Tables/TableGamesPlayed/TableGamesPlayed.vue';
import UserDropdown from '@/components/Rail/UserDropdown/UserDropdown.vue';
import NicknameDropdown from '@/components/Rail/NicknameDropdown/NicknameDropdown.vue';
import GroupDropdown from '@/components/Rail/GroupDropdown/GroupDropdown.vue';
import NetworkDropdown from '@/components/Rail/NetworkDropdown/NetworkDropdown.vue';
import NetworkSharkscopeDropdown from '@/components/Scheduling/Menus/NetworkSharkscopeDropdown/NetworkSharkscopeDropdown.vue';

export default {
  name: 'GameEntries',

  mixins: [
    AuthMixin,
  ],

  components: {
    Hero,
    TableGamesPlayed,
    Loading,
    Snackbar,
    UserDropdown,
    GroupDropdown,
    NicknameDropdown,
    NetworkDropdown,
    NetworkSharkscopeDropdown,
  },

  watch: {
    formFilters: {
      handler(newVal) {
        this.$refs.tableGamesPlayed.fetchData();
      },
      deep: true
    }
  },

  computed: {
    ...mapGetters({
      userType: 'auth/userType',
      userRoles: 'auth/userRoles',
      hasLoadedNicknamesAllMine: 'nicknames/hasLoadedNicknamesAllMine',
      themeDarkMode: 'UI/themeDarkMode',

    }),

    formFilters: {
      get() {
          return this.filters;
      },
      set(newVal) {
          this.filters = newVal;
      }
    },

    valueColorFinal: function () {
	    let output = 'black';
	  
		if (this.themeDarkMode) {
			output = 'white';
		}
	  
		return output;
	},
  },

  async created() {
    if(!this.hasLoadedNicknamesAllMine) {
      await this.$store.dispatch('nicknames/getAllMine');
    }
    //await this.allowOnlyRoles(['rail_admin', 'rail_manager', 'tracker_admin', 'tracker_manager']);
  },

  beforeDestroy() {
  },

  data() {
    return this.initialState();
  },

  methods: {
    initialState() {
      return {
        filters:{
          users: null,
          nicknames: null,
          groups: null,
          networks: null,
        }
      }
    },
  }
}